import { useAuthStore } from '~/stores/auth'

export default defineNuxtPlugin((nuxtApp) => {
  const authStore = useAuthStore()

  // 플러그인 본체(동기) — 미들웨어·컴포넌트보다 먼저 실행됨
  // refreshToken 을 Pinia 에 미리 세팅해 두면,
  // tab.global.ts / 대시보드 등 API 호출이 401 을 받았을 때
  // api.ts interceptor 가 authStore.refreshToken 을 이용해 자동 재발급할 수 있다.
  authStore.initFromStorage()

  nuxtApp.hook('app:mounted', async () => {
    if (!authStore.refreshToken) return

    try {
      // interceptor 가 이미 refresh() 를 완료한 경우 accessToken 은 있지만
      // user 는 아직 null 일 수 있으므로 isAuthenticated 와 별도로 확인한다.
      if (!authStore.isAuthenticated) {
        await authStore.refresh()
      }
      if (!authStore.user) {
        await authStore.fetchMe()
      }
    } catch {
      authStore.$patch({ accessToken: null, refreshToken: null, user: null })
      const cookie = useCookie('refreshToken')
      cookie.value = null
      await navigateTo('/login')
    }
  })
})
